export const getAuthToken = () => {
  let token = localStorage.getItem('token') || sessionStorage.getItem('token')
  return token
}

export const setAuthToken = (token) => {
  localStorage.setItem('token', token)
  sessionStorage.setItem('token', token)
}

export const deleteAuthToken = () => {
  localStorage.removeItem('token')
  sessionStorage.removeItem('token')
}

export const getUser = () => {
  let user = localStorage.getItem('user') || sessionStorage.getItem('user')
  return user ? JSON.parse(user) : {}
}

export const deleteUser = () => {
  localStorage.removeItem('user')
  sessionStorage.removeItem('user')
}



// WEBPACK FOOTER //
// ./src/utils/token.js